/* @flow */

import * as React from 'react';

import styles from './Availability.module.scss';

export type TypeAvailability = {|
  id: number,
  label: string,
  content: boolean,
|};

type TypeProps = {|
  title?: string,
  details: Array<TypeAvailability>,
  sidebar?: boolean,
|};

export default class Availability extends React.Component<*> {
  render(): React.Element<*> {
    const { title, details, sidebar }: TypeProps = this.props;
    const hasSidebar: string = sidebar ? styles.sidebar : '';

    return (
      <div className={`${styles.availability} ${hasSidebar}`}>
        {title && <h3>{title}</h3>}
        <ul>
          {details.map((item: TypeAvailability, key: number) => (
            <React.Fragment key={item.id}>
              <li>
                <React.Fragment>
                  <span>{item.label}</span>
                  {item.content === true ? (
                    <svg className={styles.approvedIcon}>
                      <use xlinkHref="#icon-approve" />
                    </svg>
                  ) : (
                    <svg className={styles.disabledIcon}>
                      <use xlinkHref="#icon-declined" />
                    </svg>
                  )}
                </React.Fragment>
              </li>
            </React.Fragment>
          ))}
        </ul>
      </div>
    );
  }
}
